<template>
  <div class="onboarding_page">
    <h2>Så hittar ni medlemmar som har registrerat sig</h2>

    <p>Samtliga medlemmar hittar ni under "Medlemmar".</p>
    <p>Om ni vill göra en finare sökning baserat på ett urval med variabler går ni till "Avancerat sök".</p>
    <p>Om du vet namnet, personnummret, telefonnummret, medlemsnummret eller e-posten till personen kan du söka på denna direkt längst uppe på sidan i sökfältet.</p>

    <p>
      Gå till
      <a href="/ml-members-control" target="_blank">Medlemmar</a> eller
      <a href="/ml-advanced-search" target="_blank">Avancerad sök</a>
    </p>

    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>
    </div>
  </div>
</template>

<script>
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

export default {
  name: 'onboarding_page10',
  props: ['onboarding_data'],
  emits: ['next_page','prev_page','update_data'],
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
      },
      immediate: true
    },
  },
  data() {
    return {
      local_onboarding_data: null,
    }
  },
  methods: {
    async download_excel(href, name) {
      const loader = this.$loading.show();

      try {
        downloadWithAxios(href, name);
      }
      catch (err) {

      }

      loader && loader.hide();
    },

    next_page() {
      this.local_onboarding_data.members_shown = true;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
